<template>
  <v-app
  :dark="darkModeHandler"
  id="inspire"
  :class="[{ 'customizer-in': customizerIn, 'box-layout': boxLayoutHandler, 'collapse-sidebar': collapseSidebarHandler, 'rtl-layout': rtlLayoutHandler}]"
  >
  <router-view></router-view>
  <notifications group="msgpad"
                   :duration="3000"
                   :width="300"
                   animation-name="v-fade-left"
                   position="bottom left">
  </notifications>
  </v-app>
</template>

<script>
import EventBus from './lib/eventBus'

export default {
  data () {
    return {
      loading         : false, // page loading
      darkMode        : false, // dark mode
      customizer      : false, // customizer
      boxLayout       : false, // box layout mode
      collapseSidebar : false, // collapse sidebar
      defaultSidebar  : '',
      rtlLayout       : false
    }
  },
  mounted () {
    let self = this
    setTimeout(() => {
      self.$notify({
        group: 'msgpad',
        type: 'success',
        title: 'Important message',
        text: 'Hello user! This is a notification!'
      })
    }, 0)
  },
  computed: {
    // computed property to get the state of dark mode
    darkModeHandler () {
      EventBus.$on('darkMode', payload => {
        this.darkMode = payload
      })
      return this.darkMode
    },
    // computed property to get the state of boxlayout event
    boxLayoutHandler () {
      EventBus.$on('boxLayout', payload => {
        this.boxLayout = payload
      })
      return this.boxLayout
    },
    collapseSidebarHandler () {
      EventBus.$on('collapseSidebar', payload => {
        this.collapseSidebar = payload
      })
      return this.collapseSidebar
    },
    // pageLoading () {
    //   var self = this
    //   setTimeout(function () {
    //     self.loading = false
    //   }, 1500)
    //   return self.loading
    // },
    // computed property to get the state of customizer
    customizerIn () {
      EventBus.$on('toggleCustomizer', payload => {
        this.customizer = payload
      })
      return this.customizer
    },
    // To set the default sidebar
    activeDefaultSidebar () {
      EventBus.$on('enableDefaultSidebar', payload => {
        this.defaultSidebar = payload
      })
      return this.defaultSidebar
    },
    rtlLayoutHandler () {
      EventBus.$on('rtlLayoutEvent', payload => {
        this.rtlLayout = payload
      })
      return this.rtlLayout
    }
  }
}
</script>
<style type="text/css">
  .vue-notification {
    padding: 3px;
    margin: 0 5px 5px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue